import React, {useEffect, useState, useRef} from 'react'
import styles from './Top10.module.css'
import Spinner from "../components/common/spinner/Spinner";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DataTable from "react-data-table-component-with-filter";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { usePermissionsContext } from "../context/contextPermissions";
import { topOptions, topCandidates } from "../services/apis";

import { useHistory, Link } from "react-router-dom";



export default function Top10() {
  const history = useHistory();

  const { permissions, setPermissions } = usePermissionsContext();

  const [isLoading, setIsLoading] = useState(true);
  const [spinnerButton, setSpinnerButton] = useState(false);
  const [showError, setShowError] = useState("");

  const [maleChecked, setMaleChecked] = useState(false);
  const [femaleChecked, setFemaleChecked] = useState(false);

  const [countries, setCountries] = useState();
  const [selectedCountries, setSelectedCountries] = useState();

  const [clients, setClients] = useState();
  const [selectedClients, setSelectedClients] = useState();

  const [years, setYears] = useState();
  const [selectedYears, setSelectedYears] = useState();

  const [attributes, setAttributes] = useState();
  const [selectedAttributes, setSelectedAttributes] = useState();

  const [campaignData, setCampaignData] = useState();
  const [isLoadingCampaign, setIsLoadingCampaign] = useState(false);
  const [showBoard, setShowBoard] = useState(false);

  const result = useRef({});

  useEffect(() => {
    async function init() {
      try {
        var jwt = localStorage.getItem("jwt", jwt);
        var topOptionsResult = await topOptions(jwt);

        var allOptions = ['countries', 'clients', 'years', 'attributes' ]
        var optionsArray = [];
        var selectedTabValues = []

        var setOption = null;
        var curTab = null;
        var optionsWithtoutAllOption = [];


        allOptions.map((option, index) => {
          curTab = option;
          setOption = `${option.charAt(0).toUpperCase() + option.slice(1)}`;
          var curOption = topOptionsResult[option]
          optionsArray = [];
          curOption.map((item, index) => {
            var item = item.replace("\\", "")
            var newOption = {'label': item, 'value': index + 1}
            return optionsArray.push(newOption);
          })


          optionsArray.map(option => option.label != 'All' ? optionsWithtoutAllOption.push(option.label) : null)
          if (curTab !== 'attributes') {
            optionsArray.unshift({ label: "All", value: "*"  })
          }

          if (curTab == 'countries') {
            result.current = {
              ...result.current,
              countries: optionsWithtoutAllOption,
            };
            setCountries(optionsArray)
            setSelectedCountries(optionsArray)

          } else if (curTab == 'clients' ) {
            result.current = {
              ...result.current,
              clients: optionsWithtoutAllOption,
            };
            setClients(optionsArray)
            setSelectedClients(optionsArray)


          } else if (curTab == 'years' ) {
            result.current = {
              ...result.current,
              years: optionsWithtoutAllOption,
            };
            setYears(optionsArray)
            setSelectedYears(optionsArray)

          } else if (curTab == 'attributes' ) {
            setAttributes(optionsArray)
            setSelectedAttributes(optionsArray)
          }

          optionsWithtoutAllOption = []
          optionsArray = [];
        })

        result.current = {
          ...result.current,
          gender: '',
          attributes: [],
        };
        setIsLoading(false);

      } catch (ex) {
        if (ex.response && ex.response.status === 401) {
        }
      }
    }

    init();
  }, []);

  const handleChange = option => {
    option == 'male' ? (
    setMaleChecked(true), setFemaleChecked(false),
    result.current = {
      ...result.current,
      gender: 'male',
    })

    :(
    setMaleChecked(false),
    setFemaleChecked(true),
    result.current = {
      ...result.current,
      gender: 'female',
    }
    )
  };

  function onChange(value, event) {

    var curTab = this.components;
    if ( curTab != "attributes") {
      if (event.action === "select-option" && event.option.value === "*") {
        this.setState(this.options);
      } else if (
        event.action === "deselect-option" &&
        event.option.value === "*"
      ) {
        this.setState([]);
      } else if (event.action === "deselect-option") {
        this.setState(value.filter((o) => o.value !== "*"));
      } else if (value.length === this.options.length - 1) {
        this.setState(this.options);
      } else {
        this.setState(value);
      }
    }

    //Set countries
    if (curTab == 'countries') {
      var countries = [];
      if (event.action == 'select-option' && event.option.label == 'All') {
        countries = []
      } else {
        value.map(value => value.label != 'All' ? countries.push(value.label) : null)
      }
      result.current = {
        ...result.current,
        countries: countries,
      };
    }

    //Set clients
    if (curTab == 'clients') {
      var clients = [];
      if (event.action == 'select-option' && event.option.label == 'All') {
        clients = []
      } else {
        value.map(value => value.label != 'All' ? clients.push(value.label) : null)
      }
      result.current = {
        ...result.current,
        clients: clients,
      };
    }

    //Set years
    if (curTab == 'years') {
      var years = [];
      if (event.action == 'select-option' && event.option.label == 'All') {
        years = []
      } else {
        value.map(value => value.label != 'All' ? years.push(value.label) : null)
      }
      result.current = {
        ...result.current,
        years: years,
      };
    }

    //Set attributes
    if (curTab == 'attributes') {
      var attributes = [];
      value.map(value => value.label != 'All' ? attributes.push(value.label) : null)

      result.current = {
        ...result.current,
        attributes: attributes,
      };
    }
  }

  async function submit(e) {
    e.preventDefault();
    setSpinnerButton(true);
    setIsLoadingCampaign(true);
    setShowError("")
    //check if gender have a value
    if (result.current.gender == "") {
      //Error gender
      setShowError('Gender')
      setShowBoard(false)
      setSpinnerButton(false);

      return
    } else if (result.current.attributes.length == 0) {
      //Error attributes
      setShowError('Attributes')
      setShowBoard(false)
      setSpinnerButton(false);

      return
    }

    try {
      const jwt = localStorage.getItem("jwt");
      var tableData = await topCandidates(jwt, result.current)
      var tableDataReverse = tableData.top_n_candidates.reverse();
      setCampaignData(tableDataReverse);


    } catch (ex) {
      if (ex && ex.response && ex.response.data && ex.response.data.message) {
        setShowBoard(false)

      }
    }
    setSpinnerButton(false);
    setIsLoadingCampaign(false);
    setShowBoard(true)
  }


  const campaignColumns = [
    {
      name: "Study Nº",
      selector: (campaign) => campaign.study_nb,
      sortable: true,
      filterable: true,
    },
    {
      name: "Client",
      selector: (campaign) => campaign.client,
      sortable: true,
      filterable: true,
    },
    {
      name: "Country",
      selector: (campaign) => campaign.country,
      sortable: true,
      filterable: true,
    },
    {
      name: "Gender",
      selector: (campaign) => campaign.gender,
      sortable: true,
      filterable: true,
    },
    {
      name: "Attributes",
      selector: (campaign) => campaign.attribute,
      sortable: true,
    },
    {
      name: "Candidate",
      selector: (campaign) => campaign.candidate,
      sortable: true,
    }
  ];

  const handleChangeClicked = (study) => {
    return history.push(
      `/view/llh/${study.client}/${study.study_nb}/${study.country}/${study.gender}/${study.candidate}/hedonic`
    );
  };

  return (
    <div className="">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {/* <div className={styles.title}>Top10</div> */}
          <div className={styles.container}>
            <div>
              <p className={styles.tab}>Gender*</p>
              <div>
                <label htmlFor="male"  className={`${styles.checkbox__male} ${styles.checkbox}`}>
                  <input
                    type="checkbox"
                    onChange={() => handleChange('male')}
                    id="male"
                    name="male"
                    checked={maleChecked}
                  />
                  Men
                </label>
                <label htmlFor="female" className={`${styles.checkbox__female} ${styles.checkbox}`}>
                  <input
                    type="checkbox"
                    onChange={() => handleChange('female')}
                    id="female"
                    name="female"
                    checked={femaleChecked}
                  />
                  Female
                </label>
                </div>
            </div>
            <div>
              <p className={styles.tab}>Countries</p>
              <ReactMultiSelectCheckboxes
                options={countries}
                placeholderButtonLabel="Select countries"
                value={selectedCountries}
                components={'countries'}
                onChange={onChange}
                setState={setSelectedCountries}

              />
            </div>
            <div>
              <p className={styles.tab}>Clients</p>
              <ReactMultiSelectCheckboxes
                options={clients}
                placeholderButtonLabel="Select clients"
                value={selectedClients}
                components={'clients'}
                onChange={onChange}
                setState={setSelectedClients}
              />
            </div>
            <div>
              <p className={styles.tab}>Years</p>
              <ReactMultiSelectCheckboxes
                options={years}
                placeholderButtonLabel="Select years"
                value={selectedYears}
                components={'years'}
                onChange={onChange}
                setState={setSelectedYears}
              />
            </div>
            <div>
              <p className={styles.tab}>Attributes*</p>
              <ReactMultiSelectCheckboxes
                options={attributes}
                placeholderButtonLabel="Select attributes"
                onChange={onChange}
                components={'attributes'}
              />
            </div>
            <div>
              {showError != "" ?
                  <div className={styles.error}>{showError} is required</div> : null
              }
              <button className={styles.top__btn} onClick={submit}>
              {spinnerButton ? (
                <FontAwesomeIcon
                  icon={faSpinner}
                  className="spinner-button"
                  spin
                />
              ) : (
                "Submit"
              )}
            </button>
          </div>
          </div>

          <div>

      {showBoard ? (
        isLoadingCampaign ? (
        <Spinner />
      ) : (
        <>
          {permissions.studies_details ? (
            <DataTable
              columns={campaignColumns}
              data={campaignData}
              pagination
              onRowClicked={handleChangeClicked}
              Clicked
            />
          ) : (
            <DataTable
              columns={campaignColumns}
              data={campaignData}
              pagination
            />
          )}
        </>
      )): null}

          </div>

        </>
      )}
    </div>
  );
}
